(() => {
  class ZanniInspirationGallery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ziBound === 'true') return;
      this.dataset.ziBound = 'true';

      this.triggers = Array.from(this.querySelectorAll('[data-zi-lightbox-trigger]'));
      this.lightbox = this.querySelector('[data-zi-lightbox]');
      if (!this.lightbox || !this.triggers.length) return;

      this.image = this.querySelector('[data-zi-lightbox-image]');
      this.title = this.querySelector('[data-zi-lightbox-title]');
      this.caption = this.querySelector('[data-zi-lightbox-caption]');
      this.product = this.querySelector('[data-zi-lightbox-product]');
      this.stage = this.querySelector('[data-zi-lightbox-stage]');
      this.index = 0;
      this.lastTrigger = null;
      this.touchStartX = 0;

      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => this.open(index));
      });

      this.querySelectorAll('[data-zi-lightbox-close]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });

      const prev = this.querySelector('[data-zi-lightbox-prev]');
      const next = this.querySelector('[data-zi-lightbox-next]');
      if (prev) prev.addEventListener('click', () => this.show(this.index - 1));
      if (next) next.addEventListener('click', () => this.show(this.index + 1));

      this.onKeydown = (event) => {
        if (this.lightbox.hidden) return;
        if (event.key === 'Escape') this.close();
        if (event.key === 'ArrowLeft') this.show(this.index - 1);
        if (event.key === 'ArrowRight') this.show(this.index + 1);
      };
      document.addEventListener('keydown', this.onKeydown);

      if (this.stage) {
        this.stage.addEventListener('touchstart', (event) => {
          this.touchStartX = event.changedTouches[0]?.clientX || 0;
        }, { passive: true });

        this.stage.addEventListener('touchend', (event) => {
          const endX = event.changedTouches[0]?.clientX || 0;
          const delta = endX - this.touchStartX;
          if (Math.abs(delta) < 45) return;
          if (delta < 0) this.show(this.index + 1);
          if (delta > 0) this.show(this.index - 1);
        }, { passive: true });
      }
    }

    disconnectedCallback() {
      if (this.onKeydown) document.removeEventListener('keydown', this.onKeydown);
    }

    open(index) {
      this.lastTrigger = this.triggers[index];
      this.show(index);
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.lightbox.hidden = false;
      const close = this.querySelector('.zi-lightbox__close');
      if (close) requestAnimationFrame(() => close.focus());
    }

    close() {
      this.lightbox.hidden = true;
      document.documentElement.style.overflow = this.previousOverflow || '';
      if (this.lastTrigger) this.lastTrigger.focus();
    }

    show(index) {
      if (!this.triggers.length) return;
      if (index < 0) index = this.triggers.length - 1;
      if (index >= this.triggers.length) index = 0;
      this.index = index;

      const trigger = this.triggers[index];
      const data = trigger.dataset;

      this.image.src = data.large || '';
      this.image.alt = data.alt || '';

      const titleText = data.title || '';
      const captionText = data.caption || '';
      this.title.textContent = titleText;
      this.caption.textContent = captionText;
      this.title.hidden = !titleText;
      this.caption.hidden = !captionText;

      if (data.productUrl) {
        this.product.href = data.productUrl;
        this.product.textContent = data.productTitle ? data.productTitle + ' →' : 'Ver producto →';
        this.product.hidden = false;
      } else {
        this.product.hidden = true;
        this.product.removeAttribute('href');
      }
    }
  }

  if (!customElements.get('zanni-inspiration-gallery')) {
    customElements.define('zanni-inspiration-gallery', ZanniInspirationGallery);
  }
})();